import api from '../../../shared/services/api';

// Wrapper dos endpoints REST do módulo Agentes (montados em /api/agentes).
// Backend valida tudo via features/Agentes/validators/agentesSchema.js — esses
// helpers só serializam. Em caso de 4xx, axios rejeita e o componente trata.
const agentesService = {
  // ---- Cards de sessões (home /agentes) ----
  cardsSessoes: () => api.get('/agentes/sessoes'),

  // ---- CRUD agente ----
  listar:           (params) => api.get('/agentes', { params }),
  obter:            (id) => api.get(`/agentes/${id}`),
  criar:            (data) => api.post('/agentes', data),
  atualizar:        (id, data) => api.put(`/agentes/${id}`, data),
  atualizarStatus:  (id, status) => api.patch(`/agentes/${id}/status`, { status }),
  excluir:          (id) => api.delete(`/agentes/${id}`),

  // ---- Vínculos sessão↔agente ----
  vincularSessao:    (id, sessao) => api.post(`/agentes/${id}/sessoes`, sessao),
  desvincularSessao: (id, vinculoId) => api.delete(`/agentes/${id}/sessoes/${vinculoId}`),

  // ---- Config por sessão (fallback / boas-vindas) ----
  obterConfigSessao: (tipo, id) => api.get(`/agentes/sessoes/${tipo}/${id}/config`),
  putConfigSessao:   (tipo, id, data) => api.put(`/agentes/sessoes/${tipo}/${id}/config`, data),

  // ---- Execuções (auditoria) ----
  execucoes: (id, params) => api.get(`/agentes/${id}/execucoes`, { params }),
  // Execuções de UMA regra específica, já com cliente + mensagem in/out resolvidos.
  execucoesPorRegra: (agenteId, regraId, params) =>
    api.get(`/agentes/${agenteId}/regras/${regraId}/execucoes`, { params }),

  // ---- Estatísticas agregadas por keyword (contadores ok/pen/fail nos nós) ----
  stats: (id) => api.get(`/agentes/${id}/stats`),

  // ---- Fase 2: Config IA por empresa ----
  obterAiConfig: () => api.get('/agentes/ai-config'),
  putAiConfig:   (data) => api.put('/agentes/ai-config', data),

  // ---- Fase 2: Conhecimento (RAG) ----
  // params aceitos: { agente_id, produto_id }
  listarConhecimento:    (params) => api.get('/agentes/conhecimento', { params }),
  postConhecimentoTexto: (data) => api.post('/agentes/conhecimento/texto', data),
  postConhecimentoUrl:   (data) => api.post('/agentes/conhecimento/url', data),
  postConhecimentoPdf:   (formData) => api.post('/agentes/conhecimento/pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  reindexarConhecimento: (id) => api.post(`/agentes/conhecimento/${id}/reindex`),
  excluirConhecimento:   (id) => api.delete(`/agentes/conhecimento/${id}`),

  // ---- Fase 2: Handoff humano ↔ bot ----
  // tipo: 'meta' | 'whatsmeow'; modo: 'bot' | 'humano'
  putModoConversa: (tipo, id, modo) => api.put(`/agentes/conversas/${tipo}/${id}/modo`, { modo }),

  // ---- Instagram: publicações de uma conta (pra vincular regra a um post) ----
  // contaId = sessao_id da sessão instagram vinculada ao agente.
  // Resposta esperada: { data: [{ id, caption, media_type, thumbnail, permalink, timestamp }] }
  listarPublicacoesInstagram: (contaId) => api.get(`/instagram/contas/${contaId}/publicacoes`),
};

export default agentesService;
